import { render, staticRenderFns } from "./Memos.vue?vue&type=template&id=222125a0&scoped=true&lang=pug&"
import script from "./Memos.vue?vue&type=script&lang=js&"
export * from "./Memos.vue?vue&type=script&lang=js&"
import style0 from "./Memos.vue?vue&type=style&index=0&id=222125a0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222125a0",
  null
  
)

component.options.__file = "Memos.vue"
export default component.exports